var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import * as ServiceClient from '../../services/client';
import { EditionClient } from './EditionClient';
import { Table } from '../../utils/Table';
import { Link } from '../../utils/Link';
import { ClientIcon } from '../../utils/Icons';
import { Checkbox, Chip } from '@mui/material';
import { colorEtatClient } from '../../utils/Classes';
import { getOriginalUser } from '../../services/utilisateur';
var originalUser = getOriginalUser();
export var Client = function (props) {
    var _a = props.withFiltre, withFiltre = _a === void 0 ? false : _a, _b = props.forceFiltres, forceFiltres = _b === void 0 ? {} : _b, _c = props.onChecked, onChecked = _c === void 0 ? null : _c;
    var _d = useState([]), clients = _d[0], setClients = _d[1];
    var _e = useState(0), total = _e[0], setTotal = _e[1];
    var getData = function (_a) {
        var _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.itemByPage, itemByPage = _c === void 0 ? 10 : _c, _d = _a.filtres, filtres = _d === void 0 ? null : _d, _e = _a.order, order = _e === void 0 ? null : _e;
        return __awaiter(void 0, void 0, void 0, function () {
            var _f, Clients, Total, error_1;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ServiceClient.getClientListe({
                                page: page,
                                itemByPage: itemByPage,
                                filtres: __assign(__assign({}, filtres), forceFiltres),
                                order: order,
                            })];
                    case 1:
                        _f = _g.sent(), Clients = _f.Clients, Total = _f.Total;
                        setClients(Clients);
                        setTotal(Total);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _g.sent();
                        setClients([]);
                        setTotal(0);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var displayClientPro = clients.filter(function (c) { return c.IsSociete; }).length > 0;
    return (_jsx(_Fragment, { children: _jsx(Table, { title: "Clients", color: "client", canEdit: originalUser.CanEditClient, renderModalEdition: function (handleClose) { return (_jsx(EditionClient, { onChange: function () { return handleClose(); } })); }, onExport: originalUser.CanExportClient
                ? function (filtres) { return ServiceClient.exportClient(filtres); }
                : null, typeFiltre: withFiltre ? 'Client' : null, refresh: getData, total: total, isResponsive: true, headers: [
                {
                    label: '',
                    component: function (value) { return (_jsx(Checkbox, { onChange: function (e, checked) {
                            onChecked(checked, value);
                        } })); },
                    hidden: onChecked === null,
                },
                {
                    label: 'Client',
                    component: function (value, _a) {
                        var color = _a.color;
                        return (_jsx(Link, { title: value.getLibelle, color: color, to: '/client/fiche/' + value.IdClient, icon: _jsx(ClientIcon, {}), bold: true }));
                    },
                    orderBy: 'RaisonSociale,Nom,Prenom',
                },
                {
                    label: 'Siret',
                    assessor: 'Siret',
                    orderBy: 'Siret',
                    hidden: !displayClientPro,
                },
                {
                    label: 'Type',
                    minWidth: true,
                    assessor: 'client_type.Libelle',
                    orderBy: 'ClientTypeId',
                    hidden: !displayClientPro,
                },
                {
                    label: 'État',
                    align: 'center',
                    minWidth: true,
                    component: function (value) { return (_jsx(Chip, { color: colorEtatClient(value.Etat), label: value.getEtatLibelle })); },
                    orderBy: 'Etat',
                },
                { label: 'Ville', assessor: 'Ville', orderBy: 'Ville' },
                {
                    label: 'CP',
                    align: 'right',
                    assessor: 'CodePostal',
                    orderBy: 'CodePostal',
                },
                {
                    label: 'Adresse',
                    assessor: 'Adresse',
                    orderBy: 'Adresse',
                },
            ], datas: clients ? clients : [] }) }));
};
//# sourceMappingURL=Client.js.map